module.exports = __webpack_public_path__ + "static/media/Simon-Edvardsson-website-tester.10d855b5.jpg";